module.exports = __webpack_public_path__ + "static/media/e_logo.d5eff22c.webp";